import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { CatalogItem } from 'entities/CatalogItem/model/types/CatalogItemSchema';
import { getSelectedOrderIsPreSubmission } from 'entities/Order/model/selectors/ordersSelectors';
import { SelectedProposal } from 'entities/Proposal/model/types/ProposalSchema';

export const useOrderItemHooks = (item: CatalogItem) => {
    const { t } = useTranslation();
    let allSuppliersSubstituted = false;
    let someSuppliersSubstituted = false;
    let substitutedProposals: SelectedProposal[] = [];
    let fulfilledProposals: SelectedProposal[] = [];
    let totalQtyFulfilled = 0;
    let totalQtySubstituted = 0;
    let totalPriceFulfilled = 0;
    let substitutionTitle = '';

    const isPreSubmission = useSelector(getSelectedOrderIsPreSubmission);

    // Once an order is fulfilled, we can check if any suppliers have substituted the item for another
    if (!isPreSubmission) {
        item.selectedProposals?.forEach((proposal) => {
            if (proposal.selectedQuantity > 0) {
                if (proposal.replacedWith) {
                    totalQtySubstituted += proposal.selectedQuantity;
                    substitutedProposals.push(proposal);
                } else {
                    totalQtyFulfilled += proposal.selectedQuantity;
                    totalPriceFulfilled +=
                        proposal.price * proposal.selectedQuantity;
                    fulfilledProposals.push(proposal);
                }
            }
        });

        const totalProposalsWithQty =
            substitutedProposals.length + fulfilledProposals.length;

        if (
            totalProposalsWithQty === substitutedProposals.length &&
            totalProposalsWithQty > 0
        ) {
            allSuppliersSubstituted = true;
            substitutionTitle = t('Unavailable');
        } else if (substitutedProposals.length > 0) {
            someSuppliersSubstituted = true;
            substitutionTitle = t('Partially available');
        }
    }

    return {
        substitutionTitle,
        allSuppliersSubstituted,
        someSuppliersSubstituted,
        substitutedProposals,
        fulfilledProposals,
        totalQtyFulfilled,
        totalQtySubstituted,
        totalPriceFulfilled,
    };
};
